import React from "react";
import { formatNumber } from '../../Utils'
import { withTranslation } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const SubtotalItem = ({ item, isExpress, allItems, t }) => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language.split('-')[0];
    
    // Order-level express (pickup/delivery + surcharges). Item flag washingAndIroningSpeedySelected can stay
    // true when the user turns express off; labels must follow isExpress, not the stale flag alone.
    const shouldShowExpress = isExpress === true && (!item.longProcessing || item.longProcessing === 0);
    const perKiloBasePrice = item?.laundry
        ? ((item.laundry.washingPerKiloPrice > 0)
            ? item.laundry.washingPerKiloPrice
            : item.laundry.washingAndIroningPerKiloPrice)
        : 0;
    // Derive per-kilo display unit from final calculated item sum so UI always matches charged price.
    const perKiloDisplayPrice = item?.laundry?.perKilo && item?.itemQuantity > 0
        ? (item.sumPrice / item.itemQuantity)
        : perKiloBasePrice;
    const shouldShowPerKiloExpress = item?.laundry?.perKilo
        && (!item?.longProcessing || item?.longProcessing === 0)
        && isExpress !== false
        && (
            item?.laundry?.washingAndIroningSpeedySelected ||
            perKiloDisplayPrice > perKiloBasePrice
        );
    return (
        <div>
            <div style={{ paddingBottom: "10px", whiteSpace: 'pre-line' }}>
                <h5 className='mb-0'>{currentLanguage === 'en' ? item.nameEn : item.name}</h5>
                <span>{currentLanguage === 'en' ? item.descriptionEn : item.description}
                </span>
            </div>
            {
                item.laundry && item.laundry.perKilo &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {item.laundry.washingPerKiloPrice > 0 ? t('cart.options.washOnly') : t('cart.options.washAndIron')}
                        {shouldShowPerKiloExpress && ` ${t('cart.options.express', 'Express')}`}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(perKiloDisplayPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.laundry && !item.laundry.perKilo && (item.laundry.washingAndIroningSelected) &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {item.laundry.cleaningAndRefreshing ? t('cart.options.cleanAndRefresh') : t('cart.options.washAndIron')}
                        {shouldShowExpress && ` ${t('cart.options.express', 'Express')}`}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                         {`${item.itemQuantity} x ${formatNumber(shouldShowExpress ? item.laundry.washingAndIroningSpeedyPrice + item.laundry.washingAndIroningPrice  : item.laundry.washingAndIroningPrice)}`} CHF

                    </span>
                </div>
            }
            {
                item.laundry && !item.laundry.perKilo && (item.laundry.washingAndManualIroningSelected) &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.washAndManualIron')}
                        {shouldShowExpress && ` ${t('cart.options.express', 'Express')}`}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                         {`${item.itemQuantity} x ${formatNumber(shouldShowExpress ? item.laundry.washingAndManualIroningSpeedyPrice + item.laundry.washingAndManualIroningPrice  : item.laundry.washingAndManualIroningPrice)}`} CHF

                    </span>
                </div>
            }
            {
                item.laundry && !item.laundry.perKilo && item.laundry.washingAndIroningSpeedySelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {isExpress === false
                            ? t('cart.options.washAndIron')
                            : (!item.longProcessing || item.longProcessing === 0)
                                ? t('cart.options.washAndIronExpress')
                                : t('cart.options.washAndIron')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.laundry.washingAndIroningSpeedyPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.tailoring && item.tailoring.buttonSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.button')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.tailoring.buttonQuantity} x ${formatNumber(item.tailoring.buttonPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.tailoring && item.tailoring.hemSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.hem')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.tailoring.hemQuantity} x ${formatNumber(item.tailoring.hemPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.tailoring && item.tailoring.zipperSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.zipper')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.tailoring.zipperQuantity} x ${formatNumber(item.tailoring.zipperPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.delivery && item.delivery.packedSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.folded')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.delivery.packedPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.delivery && item.delivery.hangerSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.onHanger')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.delivery.hangerPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.additional && item.additional.longSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.withLong')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.additional.longPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.additional && (item.additional.decorationSelected || item.additional.platedSelected) &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {item.additional.plated ? t('cart.options.withDecoAndPlated') : t('cart.options.withDeco')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.additional.decorationPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.additional && item.additional.rufflesSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.withRuffles')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.additional.rufflesPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.additional && item.additional.sequinedSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.withSequins')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.additional.sequinedPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.additional && item.additional.impregnateSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.withImpregnate')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.additional.impregnaatePrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.additional && item.additional.chiffonSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.withChiffon')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.additional.chiffonPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.additional && item.additional.bibSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.withBib')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.additional.bibPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.leather && item.leather.napaSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.napa')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.leather.napaPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.leather && item.leather.velourSelected &&
                <div className="subtotal-item">
                    <span className="item-name">
                        {t('cart.options.velour')}
                    </span>
                    <span className="spacer" />
                    <span id="item-price">
                        {`${item.itemQuantity} x ${formatNumber(item.leather.velourPrice)}`} CHF
                    </span>
                </div>
            }
            {
                item.giftCard &&
                <div className="subtotal-item">
                </div>
            }
            <div>
                <span>
                    {t('cart.quantity.label')}: {item.itemQuantity}
                </span>
                <span className="pull-right">
                    {t('cart.subtotal')}: {formatNumber(item.sumPrice)} CHF
                </span>
            </div>
            <hr />
        </div>
    );
};

export default withTranslation()(SubtotalItem);
